
import request from '../request'
import qs from 'qs'
// 就医体检评价列表
const getEvaluateInfoList = (data) => {
  return request.post(`/api/visitor/getEvaluateInfoList?${qs.stringify(data)}`, data)
}
// 就医体检评价提交
const getEvaluateInfo = (data) => {
  return request.post('/api/wx/auth/getEvaluateInfo', data)
}
// 就医记录查询 - 医院预约
const getMediciRecordInfo = (data) => {
  return request.post('/api/wx/auth/getMediciRecordInfo', data)
}
// 就医记录查询 - 视频医生
const getMedicalRecordList = (data) => {
  return request.post('/api/wx/auth/getMedicalRecordList', data)
}
// 就医记录查询咨询结果 - 视频医生
const getMedicalRecordDetail = (data) => {
  return request.post('/api/wx/auth/getMedicalRecordDetail', data)
}
// 对象数组
export default {
  getEvaluateInfoList,
  getEvaluateInfo,
  getMediciRecordInfo,
  getMedicalRecordList,
  getMedicalRecordDetail
}
